import { IMiddlewareEvent } from 'mobx-state-tree';
import { Query } from 'mst-gql';
import { ClientError } from 'graphql-request';
import { GraphQLErrorCodes } from '../../../constants';

const MSTGQL_ACTIONS = ['mutate']; // Later, we may include query for the preflight check

const isMstGqlAction = (call: IMiddlewareEvent) => (
  call.type === 'action' && MSTGQL_ACTIONS.indexOf(call.name) > -1
);

// Listens to mst-gql request actions and if the free tier error occurs brings up the modal
export default (call: IMiddlewareEvent, next: (actionCall: IMiddlewareEvent, callback?: (value: any) => any) => void) => {
  if (isMstGqlAction(call)) {
    return next(call, (value: any) => {
      if (value instanceof Query) {
        value.currentPromise().catch((error: ClientError | undefined) => {
          const usageLimitError = error?.response?.errors?.find((err) => err.extensions?.code === GraphQLErrorCodes.USAGE_LIMIT_EXCEEDED);
    
          if (usageLimitError) {
            const { newOrdersCount, usageLimit, currentPeriodUsage } = usageLimitError.extensions;
            call.tree.billing.setShowUsageLimitExceeded(true, newOrdersCount, usageLimit, currentPeriodUsage);
          }
        });
      }

      return value;
    });
  }

  return next(call);
};
